import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import BrowsingCardName from "../../../productCard/common/BrowsingCardName";
import TableHeading from "../../../TableHeading";
import ProductRates from "../../../productCard/common/ProductRates";
import clsx from 'clsx';


import {
getPortfolioColumnsAmount,
isVariantAddedToCart,
isVariantPredefined,
isVersionAdditionallyConfigured } from "../../utils";

import uniqid from 'uniqid';
import CarrierLogo from "../../../productCard/common/CarrierLogo";
import Spinner from "../../../Spinner";
import { createStyles } from "./styles";
import BcActionBlock from "../BcActionBlock";

































































var MultiProductsHeading = function MultiProductsHeading(_ref)











{var portfolio = _ref.portfolio,products = _ref.products,headingContent = _ref.headingContent,productLineId = _ref.productLineId,lastUpdateBcShortName = _ref.lastUpdateBcShortName,currentCartItem = _ref.currentCartItem,_ref$loaderInPortfoli = _ref.loaderInPortfolioId,loaderInPortfolioId = _ref$loaderInPortfoli === void 0 ? '' : _ref$loaderInPortfoli,addButton = _ref.addButton,removeButton = _ref.removeButton,configureButton = _ref.configureButton,_ref$highlightBCAndCo = _ref.highlightBCAndConfigurePortfolio,highlightBCAndConfigurePortfolio = _ref$highlightBCAndCo === void 0 ? false : _ref$highlightBCAndCo;
  /**
   * Defines total multi products portfolio width.
   * It includes products and variants amount.
   */
  var columnsAmount = getPortfolioColumnsAmount(portfolio);
  var variantsAmount = _Object$values(portfolio.products[0].bcDependentData).length;
  var classes = createStyles({ columnsAmount: columnsAmount, variantsAmount: variantsAmount });

  var isPortfolioAddedToCart = !!currentCartItem;
  var isAllProductsDisabled = products.every(function (_ref2) {var disabled = _ref2.disabled;return disabled;});

  var productsWithSomeVariants = [];

  var BCTag = function BCTag(bcIndex) {
    var isVersionConfigured = isVersionAdditionallyConfigured(portfolio, bcIndex);
    return isVersionConfigured ? /*#__PURE__*/
    React.createElement("div", { className: classes.versionWrapper }, /*#__PURE__*/
    React.createElement("span", { className: classes.version }, "Variant ".concat(bcIndex + 1)), /*#__PURE__*/
    React.createElement("p", { className: clsx(classes.bcTag, classes.additionalTag) }, "Additional")) : /*#__PURE__*/


    React.createElement("div", { className: classes.versionWrapper }, /*#__PURE__*/
    React.createElement("span", { className: classes.version }, "Variant ".concat(bcIndex + 1)), /*#__PURE__*/
    React.createElement("p", { className: clsx(classes.bcTag, classes.defaultTag) }, "Default"));


  };

  var actionButton = function actionButton(show, bcIndex) {
    var isVersionConfigured = isVersionAdditionallyConfigured(portfolio, bcIndex);
    if (removeButton && addButton) {
      return /*#__PURE__*/(
        React.createElement("div", null,
        show ?
        removeButton(portfolio.id, bcIndex, isAllProductsDisabled) :
        addButton(portfolio.id, bcIndex, portfolio.name, isAllProductsDisabled),
        configureButton && /*#__PURE__*/
        React.createElement(React.Fragment, null,
        isVersionConfigured ? /*#__PURE__*/
        React.createElement("div", { className: classes.mockButton }) :

        configureButton(portfolio.id, bcIndex, portfolio.name, isAllProductsDisabled))));





    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };

  // bcIndex is the number of variant
  // eslint-disable-next-line no-plusplus
  var _loop = function _loop(_bcIndex) {
    var productInner = _mapInstanceProperty(products).call(products,
    function (_ref3) {var _context;var imProductId = _ref3.imProductId,productDisplayName = _ref3.productDisplayName,bcDependentData = _ref3.bcDependentData,disabled = _ref3.disabled;
      var currentVariantRates = bcDependentData[_bcIndex].rates;
      return /*#__PURE__*/(
        React.createElement("div", {
          key: _concatInstanceProperty(_context = "".concat(imProductId, "_")).call(_context, _bcIndex),
          className: clsx(classes.multiVariantProduct, disabled && classes.disabledProduct) }, /*#__PURE__*/

        React.createElement("h2", { className: classes.productName }, productDisplayName), /*#__PURE__*/
        React.createElement(ProductRates, {
          id: imProductId,
          rates: currentVariantRates,
          styles: classes.ratesList,
          highlightColorStyle:
          highlightBCAndConfigurePortfolio ?
          isVersionAdditionallyConfigured(portfolio, _bcIndex) ?
          classes.ratesConfigColor :
          undefined :
          undefined })));




    });


    var isVariantAdded = isVariantAddedToCart(currentCartItem, _bcIndex);
    var predefinedValue = isVariantPredefined(currentCartItem, Number(_bcIndex));

    var shortName =
    isVariantAdded || predefinedValue ?
    currentCartItem === null || currentCartItem === void 0 ? void 0 : currentCartItem.browsingCriteria[_bcIndex].shortName[productLineId] :
    lastUpdateBcShortName;

    var content = /*#__PURE__*/
    React.createElement("div", { className: classes.multiVariantHeadingContent, key: "".concat(uniqid()) }, /*#__PURE__*/
    React.createElement("div", { className: isAllProductsDisabled ? classes.disabledProduct : '' }, /*#__PURE__*/
    React.createElement(BrowsingCardName, {
      name: highlightBCAndConfigurePortfolio ? undefined : "Variant ".concat(_bcIndex + 1),
      title: highlightBCAndConfigurePortfolio ? BCTag(_bcIndex) : undefined,
      wrapperStyles: clsx(classes.nameWrapper, classes.variantTitle),
      isPortfolioInProposal: isVariantAdded,
      showSelectedIcon: !!(removeButton && addButton) }), /*#__PURE__*/

    React.createElement(BcActionBlock, {
      actionButton: actionButton(isVariantAdded, _bcIndex),
      browsingShortName: shortName || '',
      styles: clsx(
      classes.bcActionBlock,
      !highlightBCAndConfigurePortfolio && classes.defaultBcBlock) })), /*#__PURE__*/



    React.createElement("div", { className: classes.productsInfoList }, productInner));


    productsWithSomeVariants.push(content);};for (var _bcIndex = 0; _bcIndex < variantsAmount; _bcIndex++) {_loop(_bcIndex);
  }
  var predefinedSingleVariant = isVariantPredefined(currentCartItem, 0);
  var singleVariantShortName =
  isVariantAddedToCart(currentCartItem, 0) || predefinedSingleVariant ?
  currentCartItem === null || currentCartItem === void 0 ? void 0 : currentCartItem.browsingCriteria[0].shortName[productLineId] :
  lastUpdateBcShortName;

  return /*#__PURE__*/(
    React.createElement(TableHeading, { className: classes.multiProductsHeading }, /*#__PURE__*/
    React.createElement(CarrierLogo, { carrier: portfolio.products[0].carrier, styles: classes.portfolioLogo }), /*#__PURE__*/
    React.createElement("div", null, /*#__PURE__*/

    React.createElement(BrowsingCardName, {
      name: portfolio.name,
      wrapperStyles: classes.nameWrapper,
      isPortfolioInProposal: isPortfolioAddedToCart,
      showSelectedIcon: !!(removeButton && addButton) }),

    variantsAmount === 1 && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("div", { className: clsx(isAllProductsDisabled ? classes.disabledProduct : '') }, /*#__PURE__*/

    React.createElement(BrowsingCardName, {
      name: "Variant 1",
      wrapperStyles: clsx(classes.nameWrapper, classes.variantTitle, classes.hiddenTitle),
      isPortfolioInProposal: false }), /*#__PURE__*/

    React.createElement(BcActionBlock, {
      actionButton:
      actionButton(isPortfolioAddedToCart, 0) // bcIndex === 0, because product has only 1 version
      ,
      browsingShortName: singleVariantShortName || '',
      styles: classes.bcActionBlock })), /*#__PURE__*/


    React.createElement("div", { className: classes.productsHeadings }, headingContent)),


    variantsAmount > 1 && /*#__PURE__*/
    React.createElement("div", { className: classes.multiVariantsProducts }, productsWithSomeVariants)),


    loaderInPortfolioId === portfolio.id && /*#__PURE__*/
    React.createElement("div", { className: classes.spinnerWrapper }, /*#__PURE__*/
    React.createElement(Spinner, { size: "8rem" }))));




};

export default MultiProductsHeading;
//# sourceMappingURL=index.js.map